import PaymentService from "@/services/operations/payment/PaymentService";

export default class LightPaymentService extends PaymentService {}
